import { render, staticRenderFns } from "./IndoorEnvironment.vue?vue&type=template&id=850a0a10"
import script from "./IndoorEnvironment.vue?vue&type=script&lang=js"
export * from "./IndoorEnvironment.vue?vue&type=script&lang=js"
import style0 from "./IndoorEnvironment.vue?vue&type=style&index=0&id=850a0a10&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports